@if (getLanguageOptions().length > 1 && getAppThemeName() === 'db') {
<db-menu
  design="tertiary"
  [label]="menuLabel"
>
  @for (langOption of getLanguageOptions(); track langOption;) {
  <db-menu-item>
    <button (click)="setActiveLanguage($event)">{{ langOption.toUpperCase() }}</button>
  </db-menu-item>
  }
</db-menu>
}

<ng-template #menuLabel>
  @if (!isMenuOpen) {
  <db-icon class="mr-2" color="{{color}}" size="sm">arrow-down</db-icon>
  }
  @if (isMenuOpen) {
  <db-icon class="mr-2" color="{{color}}" size="sm">arrow-up</db-icon>
  }
  @if (window.innerWidth > 850 && !iconOnly) {
  <span [style.color]="color" [style.font-weight]="200">
    Language: {{ ' ' + activeLanguage?.toUpperCase() }}
  </span>
  }
  @if (window.innerWidth < 850 || iconOnly) {
  <span [style.color]="color" [style.font-weight]="200">
    <db-icon color="{{color}}">travel</db-icon>
    {{ activeLanguage?.toUpperCase() }}
  </span>
  }
</ng-template>
